import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width="26pt" height="25pt" viewBox="0 0 26 25" {...props}>
      <Path
        d="M7.374 24.644c2.164 1.781 4.89 2.835 7.861 2.835 7.072 0 12.773-6.01 12.773-13.479 0-7.468-5.701-13.48-12.773-13.48-5.111 0-9.731 3.317-11.696 7.985"
        transform="matrix(.86667 0 0 .89286 .867 0)"
        fill="none"
        stroke="#fff"
      />
      <Path
        d="M8.352 21.258c0-2.288-1.757-4.147-3.93-4.147-2.172 0-3.93 1.859-3.93 4.147 0 2.293 1.758 4.148 3.93 4.148 2.173 0 3.93-1.855 3.93-4.148zm0 0M2.556.52l.983 7.985 7.567-1.037"
        transform="matrix(.86667 0 0 .89286 .867 0)"
        fill="none"
        strokeLinecap="square"
        stroke="#fff"
      />
      <Path
        d="M12.672 15.625h-.856V11.34h-1.394v-.645c.8-.02 1.351-.488 1.484-1.144h.766zm.976-1.648l.836-.266c.055.75.579 1.258 1.297 1.258.688 0 1.239-.477 1.239-1.227 0-.836-.579-1.258-1.247-1.258-.41 0-.8.168-1.046.442-.305-.121-.563-.246-.856-.356l.746-3.02h3.043v.845h-2.465l-.425 1.742c.257-.301.718-.45 1.171-.45 1.133 0 1.957.758 1.957 2.016 0 1.145-.835 2.07-2.117 2.07-1.226 0-2.05-.843-2.133-1.796zm0 0"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
